(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("chartcolumn", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["chartcolumn"] = factory(require("vue"));
	else
		root["chartcolumn"] = factory(root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__8__) {
return 